import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsQuotaSvg } from './WpsQuotaSvg'

export const WpsQuotaIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={WpsQuotaSvg} {...props} />
}
